import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { fmtMoney } from "@/lib/api";
import { Plus, Minus, Trash2, ShoppingBag } from "lucide-react";

export default function CartDrawer({ open, onOpenChange, store }) {
  const { items, updateQty, removeItem, total } = useCart();
  const navigate = useNavigate();
  const acc = store.secondary_color || "#3DBB2C";

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="bg-[#FAF9F6] border-l border-black/10 w-full sm:max-w-md flex flex-col">
        <SheetHeader><SheetTitle className="font-display text-2xl text-neutral-900 flex items-center gap-2"><ShoppingBag size={20} /> Mon panier</SheetTitle></SheetHeader>
        <div className="flex-1 overflow-y-auto py-4 space-y-3">
          {items.length === 0 && <p className="text-neutral-500 text-center py-10">Votre panier est vide</p>}
          {items.map((i, idx) => (
            <div key={idx} className="flex gap-3 bg-white rounded-lg p-3 border border-black/5" data-testid="cart-drawer-item">
              <div className="h-16 w-16 rounded bg-neutral-100 overflow-hidden shrink-0">{i.image && <img src={i.image} alt={i.name} className="w-full h-full object-cover" />}</div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-neutral-900 truncate">{i.name}</div>
                <div className="text-xs text-neutral-500">{i.color} · {i.size}</div>
                <div className="mono text-sm mt-1" style={{ color: acc }}>{fmtMoney(i.price)}</div>
              </div>
              <div className="flex flex-col items-end justify-between">
                <button onClick={() => removeItem(idx)} className="text-neutral-400 hover:text-red-500"><Trash2 size={15} /></button>
                <div className="flex items-center gap-1">
                  <button onClick={() => updateQty(idx, -1)} className="h-6 w-6 rounded bg-neutral-100 grid place-items-center"><Minus size={12} /></button>
                  <span className="w-6 text-center mono text-sm">{i.qty}</span>
                  <button onClick={() => updateQty(idx, 1)} className="h-6 w-6 rounded bg-neutral-100 grid place-items-center"><Plus size={12} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-black/10 pt-4 space-y-3">
            <div className="flex justify-between text-lg font-semibold text-neutral-900"><span>Total</span><span className="mono">{fmtMoney(total)}</span></div>
            <Button onClick={() => { onOpenChange(false); navigate(`/store/${store.slug}/checkout`); }} className="w-full h-12 text-white font-semibold" style={{ background: acc }} data-testid="cart-checkout-btn">
              Passer la commande
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
